import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable, of, take, tap } from 'rxjs';

import { environment } from '@env';
import { AuthenticationService } from '../auth/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementService {
  private readonly httpClient = inject(HttpClient);
  private readonly authenticationService = inject(AuthenticationService);

  retrieve(): Observable<EndUserLicenseAgreement> {
    return this.httpClient.get<EndUserLicenseAgreement>(
      environment.v3.apiBaseUrl + `/web/v1/EndUserLicenseAgreement/retrieve`,
    );
  }

  accept(endUserLicenseAgreementId: number): Observable<unknown> {
    const body = { endUserLicenseAgreementId };
    return this.httpClient
      .post(environment.v3.apiBaseUrl + `/web/v1/EndUserLicenseAgreement/accept`, body)
      .pipe(tap(() => this.updateCache(true)));
  }

  hasAgreed(): Observable<boolean> {
    const decision = this.checkFromCache();

    if (decision) {
      return of(decision.hasAgreed);
    }

    return this.authenticationService.boabaasUser$.pipe(
      take(1),
      map((user) => user.hasAgreedToEula),
    );
  }

  private updateCache(hasAgreed: boolean): void {
    const cacheEntry: EndUserLicenseAgreementEntry = {
      hasAgreed: hasAgreed,
    };

    localStorage.setItem('eula_decision', JSON.stringify(cacheEntry));
  }

  private checkFromCache(): EndUserLicenseAgreementEntry | null {
    const storageValue = localStorage.getItem('eula_decision');
    if (!storageValue) {
      return null;
    }

    const cacheEntry = JSON.parse(storageValue) as EndUserLicenseAgreementEntry;

    return cacheEntry;
  }
}

export interface EndUserLicenseAgreement {
  id: number;
  dutchVersion: string;
  englishVersion: string;
}

interface EndUserLicenseAgreementEntry {
  hasAgreed: boolean;
}
